export const SORT = {
  'best': 1,
  'time': 2,
  'price': 3,
  'distance': 4
}

export const TRAFFIC_TYPE = {
  'road_traffic': 1,
  'intersection': 2
}

export const TRAFFIC_COLORS = ['#BBB', '#FF0000', '#FFA500', '#FFD93D', '#7AA874', '#008000']

// sorted so that each color is different from the previous one
export const DEBUG_TRAVEL_LINE_COLORS = [
  '#E74C3C',
  '#3498DB',
  '#F39C12',
  '#27AE60',
  '#9B59B6',
  '#F1C40F',
  '#1ABC9C',
  '#C0392B',
  '#00A8FF',
  '#E67E22',
  '#2ECC71',
  '#8E44AD',
  '#FF6F61',
  '#16A085',
  '#EE5253',
  '#2ECCFA',
  '#D35400',
  '#A3CB38',
  '#5F27CD',
  '#10AC84'
]
